import { useNavigate } from 'react-router-dom';

import { ICardAdmin } from '@/types/ICard';

const OrganisationCell: React.FC<{ card: ICardAdmin }> = ({ card }) => {
  const navigate = useNavigate();
  const profile = card.profile;

  return (
    <td className="p-4 pb-3 hidden md:table-cell">
      {profile && (
        <>
          <p className="font-medium truncate text-sm text-gray-900">
            {profile.organisation_name}
          </p>
          <button
            type="button"
            onClick={() =>
              navigate(`/view-organisation/${profile.organisation_id}`, {
                state: {
                  fromName: 'Cards',
                  fromURL: '/',
                },
              })
            }
            className="appearance-none text-sm leading-5 text-brand-500 text-left truncate"
          >
            <span className="text-sm md:hidden">Org ID:&nbsp;</span>
            {`#${profile.organisation_id}`}
          </button>
        </>
      )}
    </td>
  );
};

export default OrganisationCell;
